import { Typography } from '@mui/material';
import { useAppSelector } from 'api';
import { PageContainer } from 'app';
import { DownloadFilters } from './components/DownloadFilters';
import { DownloadTasksTable } from './components/DownloadTasksTable';

export const DownloadDataPage = () => {
  const { currentMenuItem } = useAppSelector(state => state.menuItem);
  // Fall back to a static title when the page is reached directly (before the
  // menu item context has been resolved).
  const title =
    currentMenuItem && currentMenuItem.id !== -1
      ? currentMenuItem.text
      : 'Download Data';

  return (
    <PageContainer>
      <Typography variant="subtitle1" sx={{ mb: 2 }}>
        {title}
      </Typography>

      <DownloadFilters />

      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        Download history
      </Typography>
      <DownloadTasksTable />
    </PageContainer>
  );
};
